const CheckDateExpiry = (date) => {
  if (date) {
    const expDateObj = date.split('/');
    const today = new Date();
    const actualExpiryDate = new Date();
    const thirtyDayWarningDate = new Date();
    thirtyDayWarningDate.setFullYear(parseInt(expDateObj[1]), parseInt(expDateObj[0]) - 2, 1);
    actualExpiryDate.setFullYear(parseInt(expDateObj[1]), parseInt(expDateObj[0]) - 1, 1);

    if (actualExpiryDate <= today) {
      return 'expired';
    }
    if (thirtyDayWarningDate <= today) {
      return 'expiring soon';
    }
  }
  return '';
};

export default CheckDateExpiry;
